define.alias("shared/components/shared/publish/index", "settings/components/shared/publish/index");